export default __webpack_public_path__ + "static/media/default-image.10f35fc6.png";